define('ordersBoardFiltersLanguageView',[
  'module',
  'marionette',
  'backbone',
  'underscore',
  'settings',
  'template!ordersBoardFiltersLanguageView'
], function (
  Module,
  Marionette,
  Backbone,
  _,
  Settings,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'orders-board-filters-language-view',

    ui: {
      languageDropdown: '.language-dropdown'
    },

    events: {
      'change @ui.languageDropdown': 'onLanguageChange',
      'click @ui.languageDropdown': 'onDropdownClick'
    },

    initialize: function() {
      this.languages = this.getPreferredLanguages();
      this.selectedLanguage = null;
      
      if (this.options.filters && this.options.filters.get('webshop')) {
        var webshops = this.options.filters.get('webshop').split(',');
        for (var i = 0; i < webshops.length; i++) {
          var lang = webshops[i].split('_')[0];
          if (_.findWhere(this.languages, {code: lang})) {
            this.selectedLanguage = lang;
            break;
          }
        }
      }
      if (!this.selectedLanguage && this.languages.length > 0) {
        this.selectedLanguage = this.languages[0].code;
      }
    },

    getPreferredLanguages: function() {
      var cAccountConfig = Settings.get('cAccountConfig');
      if (cAccountConfig) {
        var userData = cAccountConfig.get('userData');
        if (userData && userData.get('preferredLanguages') && userData.get('preferredLanguages').length > 0) {
          return userData.get('preferredLanguages').map(function(lang) {
            return {
              code: lang,
              label: lang.toUpperCase()
            };
          });
        }
      }
      return [];
    },

    getWebshopsForLanguage: function(language) {
      var webshops = Settings.getWebshopLocales();
      var filteredWebshops = [];
      
      _.each(webshops, function(webshop) {
        var webshopLang = webshop.code.split('_')[0];
        if (webshopLang === language) {
          filteredWebshops.push(webshop.code);
        }
      });
      
      return filteredWebshops;
    },

    serializeData: function() {
      return {
        languages: this.languages,
        selectedLanguage: this.selectedLanguage,
        hasLanguages: this.languages.length > 0
      };
    },

    onShow: function() {
      this.onLanguageChange();
    },

    onDropdownClick: function(e) {
      e.stopPropagation();
    },

    onLanguageChange: function() {
      this.selectedLanguage = this.ui.languageDropdown.val();
      this.updateWebshopFilter();
    },

    updateWebshopFilter: function() {
      var webshops = this.getWebshopsForLanguage(this.selectedLanguage);
      this.trigger('language:change', webshops);
    },

    getSelectedWebshops: function() {
      return this.getWebshopsForLanguage(this.selectedLanguage);
    },

    hasLanguages: function() {
      return this.languages.length > 0;
    }
  });
});

